<!-- Breadcrumb -->
<div class="breadcrumb">
  <a routerLink="/dashboard" class="breadcrumb-link">Dashboard</a>
  <span class="breadcrumb-separator">&gt;</span>
  <span class="breadcrumb-item">Admin Panel</span>
  <span class="breadcrumb-separator">&gt;</span>
  <a routerLink="/admin" class="breadcrumb-link">Roles & Permissions</a>
  <span class="breadcrumb-separator">&gt;</span>
  <span class="breadcrumb-item active">{{ roleName }}</span>
</div>

<!-- Page Background -->
<div class="page-wrapper">
  <!-- Main Container -->
  <div class="permissions-container">
  <!-- Header -->
  <div class="permissions-header">
    <h1>Roles & Permissions — {{ roleName }}</h1>
    <span class="role-badge">{{ roleType }}</span>
  </div>

  <!-- Content Card -->
  <div class="permissions-card">
    <!-- Legend -->
    <div class="legend">
      <span class="legend-label">Legend:</span>
      <span class="legend-item">
        <span class="legend-icon yes">✓</span>
        Yes — permitted
      </span>
      <span class="legend-item">
        <span class="legend-icon no">✗</span>
        No — not permitted
      </span>
      <span class="legend-item">
        <span class="legend-icon na">NA</span>
        Not Applicable
      </span>
    </div>

    <!-- Permission Sections -->
    <div class="sections-list">
      <ng-container *ngFor="let section of permissionSections; let i = index">
        <!-- Section Header -->
        <div 
          class="section-item"
          [class.readonly]="isReadOnlySection(section.name)"
          [class.expanded]="section.expanded"
          (click)="toggleSection(i)">
          <span class="section-name">{{ section.name }}</span>
          <span class="section-arrow">{{ section.expanded ? '▼' : '▶' }}</span>
        </div>

        <!-- Expanded Content (Reusable Table) -->
        <div *ngIf="section.expanded && hasSectionFeatures(section.name)" class="section-content">
          <table class="permissions-table">
            <thead>
              <tr>
                <th class="feature-col">FEATURE</th>
                <th class="permission-col">ADD / CREATE</th>
                <th class="permission-col">VIEW</th>
                <th class="permission-col">EDIT / UPDATE</th>
                <th class="permission-col">DELETE</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let feature of getSectionFeatures(section.name)">
                <td class="feature-cell">
                  <span class="feature-name">{{ feature.name }}</span>
                  <span *ngIf="feature.subtitle" class="feature-subtitle">{{ feature.subtitle }}</span>
                </td>
                <td class="permission-cell">
                  <span class="perm-icon" [ngClass]="feature.addCreate">{{ feature.addCreate === 'yes' ? '✓' : feature.addCreate === 'no' ? '✗' : 'NA' }}</span>
                </td>
                <td class="permission-cell">
                  <span class="perm-icon" [ngClass]="feature.view">{{ feature.view === 'yes' ? '✓' : feature.view === 'no' ? '✗' : 'NA' }}</span>
                </td>
                <td class="permission-cell">
                  <span class="perm-icon" [ngClass]="feature.editUpdate">{{ feature.editUpdate === 'yes' ? '✓' : feature.editUpdate === 'no' ? '✗' : 'NA' }}</span>
                </td>
                <td class="permission-cell">
                  <span class="perm-icon" [ngClass]="feature.delete">{{ feature.delete === 'yes' ? '✓' : feature.delete === 'no' ? '✗' : 'NA' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <!-- Back Button -->
    <div class="back-button-container">
      <button class="back-button" (click)="goBackToRoles()">
        ← Back to Roles
      </button>
    </div>
  </div>
</div>
</div>
